import { useTranslation } from 'react-i18next';
import { Navigation } from '@/components/Navigation';

export function MyProfilePage() {
  const { t } = useTranslation('members');

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-6">
      <Navigation />
      <main className="container mx-auto px-4 py-6 max-w-7xl">
        <div className="mb-8">
          <h1 className="text-3xl font-bold">{t('pages.profile.title')}</h1>
          <p className="text-muted-foreground mt-1">{t('pages.profile.subtitle')}</p>
        </div>
        <div className="rounded-lg border border-dashed p-12 text-center">
          <p className="text-muted-foreground">{t('pages.profile.empty')}</p>
        </div>
      </main>
    </div>
  );
}
